module.exports = __webpack_public_path__ + "static/media/ScreenScrape2.498745df.jpg";